"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XRATBFDXcjs = require('./XRATBFDX.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/group/group-label.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "div";
var useGroupLabel = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useGroupLabel2(props) {
    const setLabelId = _react.useContext.call(void 0, _XRATBFDXcjs.GroupLabelContext);
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
      setLabelId == null ? void 0 : setLabelId(id);
      return () => setLabelId == null ? void 0 : setLabelId(void 0);
    }, [setLabelId, id]);
    props = {
      "aria-hidden": true,
      ...props,
      id
    };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var GroupLabel = _PTOCUU2Dcjs.forwardRef.call(void 0, function GroupLabel2(props) {
  const htmlProps = useGroupLabel(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useGroupLabel = useGroupLabel; exports.GroupLabel = GroupLabel;
